'use strict';


export default function(before) {
	return function directive() {
		return {
			require: 'ngModel',
			link: postLink,
			scope: {
				referenceDate: '<brgDate' + (before ? 'Before' : 'After'),
			},
		};

		function postLink(scope, element, attrs, ngModelCtrl) {
			ngModelCtrl.$parsers.push(function fixDate(date) {
				var referenceDate = new Date(scope.referenceDate);
				date.setFullYear(referenceDate.getFullYear());
				date.setMonth(referenceDate.getMonth());
				date.setDate(referenceDate.getDate());
				if (date < referenceDate && !before) {
					date.setDate(date.getDate()+1);
				}
				if (date > referenceDate && before) {
					date.setDate(date.getDate()-1);
				}
				return date;
			});
		}
	}
}
